<template lang="pug">
//- 流程设置进入的展示页面
#setContainer(element-loading-text="数据读取中..." v-loading="loading")
  .contral
    el-button( size="small" type="primary" @click="openBoard") 新建流程模板
    el-button(type="danger" size="small" plain :disabled="!multipleSelection.length" @click="flowDel") 删 除
    el-button(type="primary" size="small" plain :disabled="!multipleSelection.length" @click="flowOpen") 启 用
    el-button(type="primary" size="small" plain :disabled="!multipleSelection.length" @click="flowStop") 禁 用
    //- el-button(type="primary" size="small" plain :disabled="!multipleSelection.length" @click="showMoveDialog") 移 动
  .flowTable
    el-table( :data="definitionTable" @selection-change="handleSelectionChange" border height="100%")
      el-table-column(type="selection" width="55" align="center")
      el-table-column(label="流程名称" prop="flowName" align="center" v-slot="{row}")
        el-link(type="primary" @click="viewFlow(row,1)")
          span(class="tabLinkSpan" :title='row.flowName') {{ row.flowName }}
      el-table-column(label="创建人"  prop="createUserName" align="center")
      el-table-column(label="流程描述" show-overflow-tooltip prop="description" align="center")
      el-table-column(label="当前版本/最新版本"  prop="flowName" align="center" v-slot="{row}")
        el-popover(placement="top-start" title="" width="200" trigger="hover" content="当前版本不是最新版本")
          span(slot="reference")
            i.warn(v-if="row.currentVersion !== row.newestVersion" class="el-icon-warning")
        span.currentVersion {{row.currentVersion}}/
        span.newestVersion {{row.newestVersion}}
      el-table-column(label="流程状态"  prop="flowName" align="center" v-slot="{row}")
        span.stop(v-if="row.isEnable == 0") 已禁用
        span.open(v-else) 已启用
      el-table-column(label="操作"  prop="flowName" align="center" width="240px" v-slot="{row}")
        el-button(type="text" class="operBtn" @click.stop="openApprovalRecord(row)") 审批记录
        el-button(type="text" class="operBtn" @click.stop="openVersion(row)") 查看版本
        el-button(type="text" class="operBtn" @click.stop ="viewFlow(row,1)") 编辑
  .page
    el-pagination(:current-page.sync="page.pageNum"
      :page-size="page.pageSize"
      :layout="page.pageLayout"
      :total="page.totalCount"
      v-if="page.totalCount > 0"
      :page-sizes="[10, 20, 50, 100]"
      size="small"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange")
  processVersion(ref="processVersion" @updateSet="updateTree" @seeVersion="seeVersion")
  processLog(ref="processLog")
</template>

<script>
import { updateInit, flowParams, setFormData, setFormFieldList } from "../config";
import flowService from "@/CommonDP/service/flow-service";
import processVersion from "./processVersion.vue";
import processLog from "./processLog.vue";
import { mapState } from "vuex";
export default {
  components: {
    processVersion, processLog
  },
  data () {
    return {
      loading: false,
      definitionTable: [],
      page: {
        pageNum: 1,
        pageSize: 20,
        totalCount: 0,
        pageLayout: "total, sizes,prev, pager, next,jumper" // 分页组件
      },
      multipleSelection: []
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    }),
    groupId() {
      return flowParams.basicForm.groupId;
    }
  },
  mounted () {
    this.getFlowlist();
  },
  methods: {
    // 新建流程模板
    openBoard() {
      updateInit();
      this.$emit("openDesigner");
    },
    updateTree() {
      this.$emit("updateTree");
      this.getFlowlist();
    },
    updateNodes() {
      this.getFlowlist();
    },
    async getFlowlist() {
      const { page: { pageNum, pageSize }, enterpriseId } = this;
      const params = {
        groupId: this.groupId,
        pageNum,
        pageSize,
        enterpriseId
      };
      this.loading = true;
      const res = await flowService.getFlowlist(params);
      this.definitionTable = res.data;
      this.page.totalCount = res.totalCount;
      this.page.pageNum = res.pageIndex;
      this.loading = false;
    },
    // 删除
    flowDel() {
      this.flowOperator(`您确定要删除选中流程吗?`, "deleteFlow", "流程删除成功");
    },
    // 禁用
    flowStop() {
      this.flowOperator(`您确定要禁用选中流程吗?`, "disableFlow", "流程禁用成功");
    },
    // 启用
    flowOpen() {
      this.flowOperator(`您确定要启用选中流程吗?`, "enableFlow", "流程启用成功");
    },
    flowOperator(confirmContent, requestName, successTip) {
      this.$confirm(confirmContent, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async() => {
        const idList = this.multipleSelection.map(e => e.flowDefinitionId);
        await flowService[requestName](idList);
        // this.getFormGroupList();
        this.getFlowlist();
        this.$success(successTip);
        this.$emit("updateTree");
      }).catch(() => {
        // this.$message.info("已取消删除");
      });
    },
    showMoveDialog() {

    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getFlowlist();
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.getFlowlist();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 打开审批记录
    openApprovalRecord(row) {
      this.$refs.processLog.openDialog(row);
    },
    // 查看版本
    openVersion(row) {
      this.$refs.processVersion.openVersion(row);
    },
    seeVersion(row, flowKey) {
      const newRow = { ...row, flowKey: flowKey, currentVersionId: row.flowDefinitionVersionId };
      this.viewFlow(newRow, 2);
    },
    // 查看/编辑流程页面
    async viewFlow(row, mode) {
      try {
        const res = await flowService.queryFlowDef(row.currentVersionId, row.flowDefinitionId, row.flowKey);
        setFormData(res.data);
        const { formApprovePcCode, formCode } = res.data;
        const formId = formApprovePcCode || formCode;
        if (formId) this.queryFormColumns(formId);
        this.$emit("openDesigner", mode);
      } catch (error) {
        console.log(error);
      }
    },
    async queryFormColumns(formId) {
      const res = await flowService.queryFormColumns(formId);
      const array = res.data.filter((e) => e.isInternalField !== 1).map(e => {
        return {
          ...e,
          name: e.label,
          formField: e.name,
          isCanView: 1,
          isCanUpdate: 0,
          isRequired: e.required ? 1 : 0,
          isEnabled: e.required ? 1 : 0
        };
      }) || [];
      setFormFieldList('web', array);
    }
  }
};
</script>

<style lang="scss" scoped>
#setContainer{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.flowTable{
  height: 1px;
  flex-grow: 1;
  margin: var(--middle-space) 0;
}
.page{
  height: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.contral{
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.stop {
  color: #ec3226;
}
.open {
  color: #00b632;
}
.warn{
  color: #ec3226;
}
</style>
